import { render, staticRenderFns } from "./RialSalesReport.vue?vue&type=template&id=483c4aec"
import script from "./RialSalesReport.vue?vue&type=script&lang=js"
export * from "./RialSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports